import * as Promise from 'bluebird';

Promise.config({ cancellation: true });
// Takes a delay, audio object and any number of sound src then plays them and resolves after delay when the last sound is played
// Example use:
// await playMultipleSounds(500, audio, 'src', 'src');
// HOW TO CLEANUP:
// this.promise = playMultipleSounds(500, audio, 'src', 'src').then()....then()...
// this.promise.cancel();

export const playMultipleSounds = (delay = 0, audio, ...sounds) => {
  return new Promise((resolve, reject, onCancel) => {
    let currentSound = null;

    const soundsArray = [];
    const filteredSounds = sounds.filter(s => s !== undefined);

    filteredSounds.forEach(val => {
      if (Array.isArray(val)) {
        val.forEach(s => {
          const sound = audio[s.src];
          if (sound && 'once' in sound) {
            soundsArray.push(sound);
          }
        });
      } else {
        const sound = audio[val.src];
        if (sound && 'once' in sound) {
          soundsArray.push(sound);
        }
      }
    });

    if (!soundsArray.length) reject('No sounds to play');

    soundsArray.forEach((val, idx) => {
      if (idx < soundsArray.length - 1) {
        val.once('end', () => {
          currentSound = soundsArray[idx + 1];
          currentSound.play();
        });
      } else {
        val.once('end', () => resolve());
      }
    });

    const timerID = setTimeout(() => {
      currentSound = soundsArray[0];
      currentSound.play();
    }, delay);

    onCancel(function() {
      if (currentSound) {
        currentSound.stop();
      }

      clearTimeout(timerID);
    });
  });
};

// Helper function to delay a promise chain
export const delay = t => {
  return new Promise((resolve, reject, onCancel) => {
    const timerID = setTimeout(resolve, t);

    onCancel(function() {
      clearTimeout(timerID);
    });
  });
};
